import Application from '@/components/Application';
import Campaign from '@/components/Campaigns/Campaign';
import Campaigns from '@/components/Campaigns/Campaigns';
import Login from '@/components/External/Login';
import Logout from '@/components/External/Logout';
import MFA from '@/components/External/MFA';
import ExternalWrapper from '@/components/ExternalWrapper';
import Settings from '@/components/Settings/Settings';
import AccountSettings from './components/Account/AccountSettings';
import Agent from './components/Agents/Agent';
import Agents from './components/Agents/Agents';
import Billing from './components/Billing/Billing';
import Calendar from './components/Calendars/Calendar';
import Calendars from './components/Calendars/Calendars';
import Calls from './components/Calls/Calls';
import ContactLists from './components/ContactList/ContactLists';
import ContactTabs from './components/Contacts/ContactTabs';
import { KpiDashboard } from './components/Dashboard/KPIdashboard';
import Documents from './components/Documents/Documents';
import BlandAiIntegration from './components/Integrations/Apps/BlandIntegration';
import CalendlyIntegration from './components/Integrations/Apps/CalendlyIntegration';
import GoogleCalendarIntegration from './components/Integrations/Apps/GoogleCalendarIntegration';
import InstantlyIntegration from './components/Integrations/Apps/InstantlyIntegration';
import MondayIntegration from './components/Integrations/Apps/MondayIntegration';
import RetoolIntegration from './components/Integrations/Apps/RetoolIntegration';
import RingbaIntegration from './components/Integrations/Apps/RingbaIntegration';
import SalesforceIntegration from './components/Integrations/Apps/SalesforceIntegration';
import TwilioIntegration from './components/Integrations/Apps/TwilioIntegration';
import Integrations from './components/Integrations/Integrations';
import Outcome from './components/Outcome/Outcome';
import Pathway from './components/Pathways/Pathway';
import PathwayBuilder from './components/Pathways/PathwayBuilder';
import Scenarios from './components/Scenarios/Scenarios';
import ScoreCard from './components/ScoreCard/ScoreCard';
import Scorecards from './components/ScoreCard/Scorecards';
import Team from './components/Team/Team';
import TrainerInitializer from './components/Trainer/TrainerInitializer';
import JanusAudioTest from './components/WebRTC/JanusSipTest';
import Webhooks from './components/Webhooks/Webhooks';

const routes = [
  {
    url: '/',
    element: <Application />,
    private: false,
  },
  {
    url: '/sip',
    exact: true,
    element: <JanusAudioTest />,
    private: true,
  },
  {
    url: '/dashboard',
    element: <KpiDashboard />,
    private: true,
  },
  {
    url: '/login',
    exact: true,
    element: (
      <ExternalWrapper>
        <Login />
      </ExternalWrapper>
    ),
    private: false,
  },
  {
    url: '/mfa/:method/:value/:token',
    exact: true,
    element: (
      <ExternalWrapper>
        <MFA />
      </ExternalWrapper>
    ),
    private: false,
  },
  {
    url: '/outcomes',
    exact: true,
    element: <Outcome />,
    private: true,
  },
  {
    url: '/contacts',
    exact: true,
    element: <ContactTabs />,
    private: true,
  },
  {
    url: '/lists',
    exact: true,
    element: <ContactLists />,
    private: true,
  },
  {
    url: '/documents',
    exact: true,
    element: <Documents />,
    private: true,
  },
  {
    url: '/campaigns/:campaignId',
    exact: true,
    element: <Campaign />,
    private: true,
  },
  {
    url: '/campaigns',
    exact: true,
    element: <Campaigns />,
    private: true,
  },
  {
    url: '/agents/:agentId',
    exact: true,
    element: <Agent />,
    private: true,
  },
  {
    url: '/agents',
    exact: true,
    element: <Agents />,
    private: true,
  },
  {
    url: '/calls',
    exact: true,
    element: <Calls />,
    private: true,
  },
  {
    url: '/call_scenarios',
    exact: true,
    element: <Scorecards />,
    private: true,
  },
  {
    url: '/team',
    exact: true,
    element: <Team />,
    private: true,
  },
  {
    url: '/billing',
    exact: true,
    element: <Billing />,
    private: true,
  },
  {
    url: '/account-settings',
    exact: true,
    element: <AccountSettings />,
    private: true,
  },
  {
    url: '/settings',
    exact: true,
    element: <Settings />,
    private: true,
  },
  {
    url: '/integrations/instantly',
    exact: true,
    element: <InstantlyIntegration />,
    private: true,
  },
  {
    url: '/integrations/calendly',
    exact: true,
    element: <CalendlyIntegration />,
    private: true,
  },
  {
    url: '/integrations/ringba',
    exact: true,
    element: <RingbaIntegration />,
    private: true,
  },
  {
    url: '/integrations/monday',
    exact: true,
    element: <MondayIntegration />,
    private: true,
  },
  {
    url: '/integrations/salesforce',
    exact: true,
    element: <SalesforceIntegration />,
    private: true,
  },
  {
    url: '/integrations/bland',
    exact: true,
    element: <BlandAiIntegration />,
    private: true,
  },
  {
    url: '/integrations/twilio',
    exact: true,
    element: <TwilioIntegration />,
    private: true,
  },
  {
    url: '/integrations/retool',
    exact: true,
    element: <RetoolIntegration />,
    private: true,
  },
  {
    url: '/integrations/googlecalendar',
    exact: true,
    element: <GoogleCalendarIntegration />,
    private: true,
  },
  {
    url: '/integrations',
    exact: true,
    element: <Integrations />,
    private: true,
  },
  {
    url: '/pathways/:pathwayId',
    exact: true,
    element: <Pathway />,
    private: true,
  },
  {
    url: '/pathway-builder',
    exact: true,
    element: <PathwayBuilder />,
    private: true,
  },
  {
    url: '/webhooks',
    exact: true,
    element: <Webhooks />,
    private: true,
  },
  {
    url: '/scenarios',
    exact: true,
    element: <Scenarios />,
    private: true,
  },
  {
    url: '/scenarios/:scenarioId',
    exact: true,
    element: <TrainerInitializer />,
    private: true,
  },
  {
    url: '/call_scenarios/:callId',
    exact: true,
    element: <ScoreCard />,
    private: true,
  },
  {
    url: '/calendars',
    exact: true,
    element: <Calendars />,
    private: true,
  },
  {
    url: '/calendars/:calendarId',
    exact: true,
    element: <Calendar />,
    private: true,
  },

  {
    url: '/logout',
    exact: true,
    element: <Logout />,
    private: false,
  },
];

export { routes };
